export default "__VITE_ASSET__CA_tMvqH__"